<template>
  <div class="con">
    <!-- 头部 -->
    <headbox></headbox>

    <!-- 内容 -->
    <newsbox></newsbox>
    <!-- 底部 -->
    <footbox></footbox>
  </div>
</template>

<script>
import newsbox from './components/newsbox2'
import headbox from './components/home/headbox' 

import footbox from './components/footbox'
export default {
  components: {
    newsbox,
    headbox,
    footbox,
  },
  data () {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>

</style>
